import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  fetchListOfCriteria,
  fetchEntitiesList,
  createNewCriteria,
  fetchListTemplateType,
  fetchPromoListTemplateType,
  fetchPreviewTemplate,
  fetchcreateBulkNotification,
  fetchDataCriteriaById,
  fetchDataTemplateById,
  fetchRequestDownload,
  createRequestDownload,
  // removeCriteria,
  // removeNotification,

} from "@/services/bulkNotification";

@Module({
  namespaced: true
})
export default class bulkNotification extends VuexModule {
  // state
  listOfCriteriaData = [];
  listOfEntities = [];
  newCriteriaCreation = [];
  templateTypeList = [];
  promoTemplateTypeList = [];
  previewTemplate = [];
  bulkNotification = [];
  dataCriteriaById = [];
  dataTemplateById = [];
  request = []

  // Action 

  @Action
  public async createRequestDownload(payload) {
    try {
      const data = await createRequestDownload(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchRequest(payload) {
    try {
      const data = await fetchRequestDownload(payload);
      this.context.commit("setRequest", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchListOfCriteria(payload) {
    try {
      const data = await fetchListOfCriteria(payload);
      this.context.commit("setFetchlistofcriteria", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchEntities(payload) {
    try {
      const data = await fetchEntitiesList(payload);
      this.context.commit("setFetchEntitylist", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createCriteria(payload) {
    try {
      const data = await createNewCriteria(payload);
      this.context.commit("setFetchCreateNewCriteria", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTemplateTypeList(payload) {
    try {
      const data = await fetchListTemplateType(payload);
      this.context.commit("setFetchListTemplateType", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPromoTemplateTypeList(payload) {
    try {
      const data = await fetchPromoListTemplateType(payload);
      this.context.commit("setPromoTemplateType", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  //delete not required for now

  // @Action
  // public async deleteCriteria(payload) {
  //   try {
  //     const data = await removeCriteria(payload);
  //     return data
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  // @Action
  // public async deleteNotification(payload) {
  //   try {
  //     const data = await removeNotification(payload);
  //     return data
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  @Action
  public async fetchTemplateToPreview(payload) {
    try {
      const data = await fetchPreviewTemplate(payload);
      this.context.commit("setPreviewTemplate", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createBulkNotification(payload) {
    try {
      const data = await fetchcreateBulkNotification(payload);
      this.context.commit("setCreateBulkNotification", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchDetailsCriteriaById(payload) {
    try {
      const data = await fetchDataCriteriaById(payload);
      this.context.commit("setDetailsCriteriaById", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchDetailsTemplateById(payload) {
    try {
      const data = await fetchDataTemplateById(payload);
      this.context.commit("setDetailsTemplateById", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  //Mutations
  @Mutation
  public setRequest(data: any) {
    this.request = data;
  }

  @Mutation
  public setFetchlistofcriteria(data: any) {
    this.listOfCriteriaData = data;
  }

  @Mutation
  public setFetchEntitylist(data: any) {
    this.listOfEntities = data;
  }

  @Mutation
  public setFetchCreateNewCriteria(data: any) {
    this.newCriteriaCreation = data;
  }

  @Mutation
  public setFetchListTemplateType(data: any) {
    this.templateTypeList = data;
  }
  @Mutation
  public setPromoTemplateType(data: any) {
    this.promoTemplateTypeList = data;
  }

  @Mutation
  public setPreviewTemplate(data: any) {
    this.previewTemplate = data;
  }

  @Mutation
  public setCreateBulkNotification(data: any) {
    this.bulkNotification = data;
  }

  @Mutation
  public setDetailsCriteriaById(data: any) {
    this.dataCriteriaById = data;
  }

  @Mutation
  public setDetailsTemplateById(data: any) {
    this.dataTemplateById = data;
  }

  //Getters
  get GetFetchListOfCriteria() {
    return this.listOfCriteriaData;
  }

  get GetListOfEntities() {
    return this.listOfEntities;
  }

  get GetNewCriteria() {
    return this.newCriteriaCreation;
  }

  get GetTemplateTypeList() {
    return this.templateTypeList;
  }
  get GetPromoTemplateTypeList() {
    return this.promoTemplateTypeList;
  }

  get GetPreviewTemplate() {
    return this.previewTemplate;
  }

  get GetBulkNotification() {
    return this.bulkNotification;
  }

  get GetDataCriteriaById() {
    return this.dataCriteriaById;
  }

  get GetDataTemplateById() {
    return this.dataTemplateById;
  }

  get GetRequestDownload() {
    return this.request
  }
}
